import styled from "styled-components";

export const StyledLinearReleaseDashboard = styled.div``;
